import { currencies } from '@/constants/currencies';
import { WebbedHotel } from '@/types/webbeds';
import { calculateHotelPrices } from '@/utils/calculateHotelPrices';
import { numberWithCommas } from '@/utils/numberWithcommas';
import { slugifyOptions } from '@/utils/slugifyOptions';
import { faStar } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import slugify from 'slugify';

export function webbedFormatHotel(hotel: WebbedHotel, duration: number = 1, currency: string) {

    const stars = Array.from({ length: +hotel.stars }, (_, i) => (
        <FontAwesomeIcon icon={faStar} key={i} className="h-3 w-3 " />
    ));

    const {
        discountPercent,
        originalPrice,
        originalPricePerNight,
        pricePerNight,
        totalPrice
    } = calculateHotelPrices(hotel.minPrice, hotel.offers?.charge, duration)

    return {
        id: hotel.id,
        name: hotel.name,
        city: hotel.city,
        country: hotel.country,
        code: hotel.id,
        images: hotel.images,
        stars: stars,
        rating: hotel.rating,
        latitude: hotel.lat,
        longitude: hotel.lng,
        amenities: hotel.amenities,
        businessFacilities: hotel.business,
        leisureFacilities: hotel.leisure,
        address: hotel.address,
        phone: hotel.phone,
        facilities: hotel.facilities,
        checkInTime: hotel.checkIn,
        checkOutTime: hotel.checkOut,
        minimumPrice: hotel.minPrice ? `${currencies[currency]}${hotel.minPrice?.toFixed(0)}` : '',
        totalPrice: totalPrice && hotel.minPrice ? `${currencies[currency]}${numberWithCommas(Math.ceil(totalPrice)?.toString())}` : '',
        pricePerNight: pricePerNight && hotel.minPrice ? `${currencies[currency]}${numberWithCommas(Math.ceil(pricePerNight)?.toString())}` : '',
        accommodationType: hotel.accommodationType,
        offer: hotel.offers,
        originalPrice: originalPrice && hotel.minPrice ? `${currencies[currency]}${numberWithCommas(originalPrice.toFixed(0))}` : '',
        originalPricePerNight: originalPricePerNight && hotel.minPrice ? `${currencies[currency]}${numberWithCommas((originalPricePerNight).toFixed(0))}` : '',
        discountPercent: hotel.offers && discountPercent < 100 ? `${(discountPercent).toFixed(0)}` : '',
        createdAt: hotel.createdAt,
        updatedAt: hotel.updatedAt,
        aiDescription: hotel.aiDescription,
        matchPercentage: hotel.matchPercentage,
        navigateTo: (
            { start, end, passenger = 'a1-c-1', itineraryId, }: {
                nationality?: string, residency?: string,
                start?: string, end?: string, passenger?: string, itineraryId?: string
            }) => {
            const citySlug = slugify(hotel.city || '', slugifyOptions);
            const hotelNameSlug = slugify(hotel.name, slugifyOptions);
            const countrySlug = slugify(hotel.country, slugifyOptions);
            return (start && end) ? `/hotel/${countrySlug}/${citySlug}/${hotelNameSlug}?checkIn=${start}&checkOut=${end}&passenger=${passenger}&lat=${hotel.lat}&lng=${hotel.lng}${itineraryId ? `&itineraryId=${itineraryId}` : ''}` : '';
        }
    };
}

export type WebbedFormattedHotelType = ReturnType<typeof webbedFormatHotel>;
